import React, { useEffect, useRef } from "react"
import party from "party-js";

interface IconImageProps {
    children: React.ReactNode
    confetti?: boolean
}

const IconImage: React.FC<IconImageProps> = ({ children, confetti = false }) => {

    const confettiRef = useRef<HTMLDivElement>(null);
    
    useEffect(() => {
        if (!confettiRef.current || !confetti) return;
        console.log("CONFETTI")
        party.confetti(confettiRef.current, {
            count: party.variation.range(20, 40),
        });
    }, [confettiRef]);

    return (
        <div className="
            flex
            items-center
            justify-center
            bg-customSecondary
            bg-opacity-80
            rounded-full
            p-6
            [&>*]:fill-white
            [&>*]:w-24
            [&>*]:h-24
        " ref={confettiRef}>
            {children}
        </div>
    )
}

export default IconImage

